/**
 * Combined Apostille / MFA-legalisation Q&A set (Wave 1 + Wave 2), de-duplicated by slug.
 * Every /apostille question surface (hub, /apostille/q/$slug, JSONL feed, sitemap)
 * reads from here so a new wave lands everywhere at once.
 */
import { APOSTILLE_QA, type ApostilleQA } from "./questions-500";
import { APOSTILLE_QA_WAVE2 } from "./questions-wave2";
import { APOSTILLE_QA_WAVE3 } from "./questions-wave3";
import { liftToFloor } from "../_qa/topup-merge";
import { APOSTILLE_TOPUP_AXIS } from "../_qa/topup-axes";

const merged: ApostilleQA[] = [];
const seen = new Set<string>();
for (const qa of [...APOSTILLE_QA, ...APOSTILLE_QA_WAVE2, ...APOSTILLE_QA_WAVE3]) {
  if (seen.has(qa.slug)) continue;
  seen.add(qa.slug);
  merged.push(qa);
}

liftToFloor<ApostilleQA["cluster"], ApostilleQA>(merged, {
  prefix: "apostille-t7",
  asOf: "ข้อมูลทบทวน ณ สิงหาคม 2569 ไทยยังไม่ออกตรา Apostille จนกว่าอนุสัญญาจะมีผลวันที่ 28 กุมภาพันธ์ 2027 ระหว่างนี้ใช้เส้นทางนิติกรณ์กรมการกงสุลแล้วรับรองสถานทูตปลายทางตามที่กำหนด เว็บไซต์ไม่แสดงค่าบริการ ขอใบเสนอราคาเฉพาะเคสได้ทางโทรศัพท์ LINE หรืออีเมล",
  authorityTh: "หน่วยงานปลายทางผู้รับเอกสาร",
  clusterTh: "งานรับรองเอกสารเพื่อใช้ต่างประเทศ",
  primary: APOSTILLE_TOPUP_AXIS,
  clusters: { documents: "documents", process: "process", risk: "problem", location: "country" },
});

export const APOSTILLE_QA_ALL: ApostilleQA[] = merged;

export const APOSTILLE_QA_ALL_BY_SLUG: Record<string, ApostilleQA> = Object.fromEntries(
  APOSTILLE_QA_ALL.map((q) => [q.slug, q]),
);

/** Total distinct phrasings covered (question + synonym clusters). */
export const APOSTILLE_QA_PHRASING_COUNT = APOSTILLE_QA_ALL.reduce(
  (n, qa) => n + 1 + qa.synonyms.length,
  0,
);
